import { render } from "./Mostrar-Grupos-Solidarios.vue?vue&type=template&id=680e923c&scoped=true"
import script from "./Mostrar-Grupos-Solidarios.vue?vue&type=script&lang=js"
export * from "./Mostrar-Grupos-Solidarios.vue?vue&type=script&lang=js"

import "./Mostrar-Grupos-Solidarios.vue?vue&type=style&index=0&id=680e923c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680e923c"]])

export default __exports__